import React, { useEffect } from "react";
import LoginForm from "../components/Login/LoginForm";
import SignupForm from "../components/Login/SignupForm";
import { userEvents } from '../utils/analytics';
import "./Login.css";

function Login() {
  useEffect(() => {
    userEvents.pageView('login', { type: 'auth' });
  }, []);

  return (
    <div className="login">
      <LoginForm />
      <div className="auth-divider"></div>
      <SignupForm />
    </div>
  );
}


export default Login;
